import { useEffect, useState } from "react";
import { getStaticUrl, setBgImage, setDocumentTitle } from "../../../utils";
import { motion } from "framer-motion";
import qrCode from '../../../assets/my/app_qr.svg';
import bg from '../../../assets/my/app-page-bg.png';
import { getFanAppPageConfig } from "../../../api/transport/configurationTransport";
import { FanAppPageConfig } from "../../../types/configuration/fan-app";
import { FeedbackForm } from "./FeedbackForm";
import { TextBlock } from "./TextBlock";
import { ScrollDownIcon } from "../../../components/Icon";
import { Carousel, Image } from "antd";
import { PageButton } from "./PageButton";
import { PhotoCarousel } from "../../../components/PhotoCarousel";

const MyAppPage = () => {
    const [fanAppPageConfig, setFanAppPageConfig] = useState<FanAppPageConfig>(null);

    useEffect(() => {
        setBgImage(bg);
        getFanAppPageConfig().then((data) => {
            setFanAppPageConfig(data);
        });

        setDocumentTitle(`Приложение болельщика - Официальный сайт ФК «Родина»`);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            const anchorComment = document.getElementById('firstScreen');
            if (anchorComment) {
                anchorComment.scrollIntoView({ behavior: "smooth" });
            }
        }, 0);
    }, []);

    return (
        <div id="firstScreen" style={{ fontFamily: 'Futura, sans-serif' }}>
            <div className="text-xl bg-fixed bg-[url(https://fcrodina.com/static/media/app-page-bg.79e35420a8ad7ba901c0.png)]">
                <div className="aspect-video w-full box-border bg-[url(https://fcrodina.com/uploads/f45c347c250e0d4eabcb7fc520284af3.jpg)] bg-full bg-cover">
                    <div className="relative max-h-screen h-full box-border flex flex-col items-center justify-end gap-8 pb-4 sm:pb-8 pr-20 sm:pr-32">
                        <motion.div
                            initial={{ opacity: 0, y: -500 }} // Начальное состояние (невидимо и смещено вверх)
                            animate={{ opacity: 1, y: 0 }}  // Конечное состояние (видимо и на месте)
                            transition={{ duration: 0.5 }}  // Длительность анимации
                            className="text-3xl sm:text-8xl font-bold italic text-white"
                        >
                            Привет, Родной!
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, x: 50, scale: 0.9 }} // Начальное состояние (невидимо и смещено вниз)
                            animate={{ opacity: 1, x: 0, scale: 1 }}  // Конечное состояние (видимо и на месте)
                            transition={{ duration: 0.5, type: 'spring', stiffness: 100 }}  // Длительность анимации
                        >
                            <PageButton title="ТВОЕ ПРИЛОЖЕНИЕ ТУТ" href="https://my.fcrodina.com" target="_blank" />
                        </motion.div>
                        <motion.div
                            animate={{ y: [0, 20, 0] }}
                            transition={{
                                duration: 2.5,
                                repeat: Infinity, // бесконечно
                                repeatType: "loop", // тип повтора
                                ease: "easeInOut"
                            }}
                            className="hidden text-white opacity-75 absolute -bottom-2"
                        >
                            <ScrollDownIcon />
                        </motion.div>
                    </div>
                </div>
                <div className="max-w-3xl mx-auto text-white text-xl sm:text-2xl">
                    <div className="flex flex-col gap-8 sm:gap-12 pt-12">
                        <TextBlock>
                            <p>
                                Устанавливай приложение "Родные" и забирай максимум впечатлений от матчдэй любимого клуба.
                            </p>
                        </TextBlock>
                        <TextBlock title="Награждение Лучшего игрока матча">
                            {!!fanAppPageConfig?.mvpCarousel?.length && <div className="w-full max-w-[600px] mx-auto"><PhotoCarousel images={fanAppPageConfig.mvpCarousel.map(i => getStaticUrl(i))} aspect="square" cover/></div>}
                            {!fanAppPageConfig?.mvpCarousel?.length && <img src={getStaticUrl("/uploads/images/04.06.2025%20Родина%20-%20Сочи-1069.jpg")} className="w-full rounded-xl" />}
                            <p>
                                Голосуй за лучшего и лично вручи ему приз.
                            </p>
                            <div className="flex flex-row gap-4 pt-6 justify-center sm:justify-start">
                                <PageButton title="Вперёд" href="https://my.fcrodina.com/#/vote" />
                            </div>
                        </TextBlock>
                        <TextBlock title="Задай вопрос тренеру">
                            <p>
                                Не стесняйся! Зоран открыт к общению и любит вопросы от болельщиков.<br />
                                Лучший зададим на послематчевой пресс-конференции, а ответ опубликуем в <a href="https://shop.fcrodina.com/#rec774999628">программке</a>
                            </p>
                            <div className="flex flex-row gap-4 pt-6 justify-center sm:justify-start">
                                <PageButton title="Задай вопрос" href="https://my.fcrodina.com/#/ask-coach" />
                            </div>
                        </TextBlock>
                        <TextBlock title="Конкурс прогнозов">
                            <p>
                                Кто как не ты в курсе всех новостей о родной команде!<br />
                                Используй эти знания, чтобы порадовать семью щедрым подарком от наших друзей из Fix Price
                            </p>
                            <div className="flex flex-row gap-4 pt-6 justify-center sm:justify-start">
                                <PageButton title="Оставить прогноз" href="https://my.fcrodina.com/#/guess-score" />
                            </div>
                        </TextBlock>
                        <TextBlock title="Цифры решают!">
                            <p>
                                И приносят тебе солидный куш в программе лояльности. <br />
                                Выбирай игрока, которого тебе подсказывает интуиция, и набранный им рустат индекс сразу прилетит тебе бонусами на личный счёт в приложении
                            </p>
                            <div className="flex flex-row gap-4 pt-6 justify-center sm:justify-start">
                                <PageButton title="Выбрать игрока" href="https://my.fcrodina.com/#/top-index" />
                            </div>
                        </TextBlock>
                        <TextBlock>
                            <p>
                                Геймзона с играми, интерактивами и викторинами только набирает обороты! <br />
                                Наши планы зависят от твоих предпочтений, поэтому пиши, что лично ты хочешь увидеть в приложении для болельщика!
                            </p>
                            {/*<div className="flex flex-row gap-4 pt-6">
                                <Button title="Пара простых вопросов" href={fanAppPageConfig?.feedbackFormUrl} disabled={!fanAppPageConfig?.feedbackFormUrl} />
                            </div>*/}

                            <div className="hidden mx-auto text-center">
                                <img src={qrCode} alt="Ссылка на приложение" />
                            </div>
                            <FeedbackForm />
                        </TextBlock>
                    </div>
                </div>
                <div className="flex flex-col items-center py-24">
                    <motion.div
                        initial={{ opacity: 0, x: 50, scale: 0.9 }} // Начальное состояние (невидимо и смещено вниз)
                        animate={{ opacity: 1, x: 0, scale: 1 }}  // Конечное состояние (видимо и на месте)
                        transition={{ duration: 0.5, type: 'spring', stiffness: 100 }}  // Длительность анимации
                    >
                        <PageButton title="Установи приложение" href="https://my.fcrodina.com" target="_blank" />
                    </motion.div>
                </div>
            </div>
        </div>
    )
}

export default MyAppPage;